import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {},
  modal: {
    width: '100%',
    height: '100%',
  },
  modalInner: {
    width: '100%',
    height: '100%',
    background: '#fafafa',
    padding: '8px 16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(1320)]: {
      padding: '24px',
    },
    [theme.breakpoints.down(1000)]: {
      padding: '0px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
  cards: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    paddingBottom: '98px',
    maxWidth: 1440,
    maxHeight: 900,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '60px',
    },
  },
  inner: {
    padding: '24px 40px 0px 32px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      height: 'auto',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
}))
